import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Link } from 'react-router-dom';
import LoginRegister from './components/LoginRegister';
import Dashboard from './components/Dashboard';
import Education from './pages/Education';
import Pricing from './pages/Pricing';
import About from './pages/About';
import './App.css';
import Footer from './components/Footer'; // Import the Footer Copyright component
import ResetPassword from './components/ResetPassword';
import { FaBars } from 'react-icons/fa'; // Import Hamburger Icon


// Log the current environment
console.log(`Running in ${process.env.NODE_ENV || 'development'} mode`);


// Custom Hook for Dynamic Page Titles
const usePageTitle = () => {
    const location = useLocation();

    useEffect(() => {
        const pathTitleMap = {
            '/': 'Home',
            '/dashboard': 'Dashboard',
            '/education': 'Education',
            '/pricing': 'Pricing',
            '/about': 'About',
        };

        const pageTitle = pathTitleMap[location.pathname] || 'Salva | App';
        document.title = `Salva | ${pageTitle}`;
    }, [location]);
};

// Custom Hook to Detect Dashboard Route for Header Visibility
const useIsDashboard = () => {
    const location = useLocation();
    return location.pathname.includes('/dashboard');
};

function HomePage({ onLoginClick }) {
    return (
        <div className="home-container">
            {/* Welcome Section */}
            <section className="welcome-section">
                <br></br>
                <br></br>
                <h1><strong>Welcome to Salva</strong></h1>
                <p>A stress free way to manage your taxes. <br></br>Grow your knowledge, file your taxes, visualize your finances.</p>
            </section>

            {/* Information Sections */}
            <section className="info-section">
                <div className="info-box">
                    <img src={`${process.env.PUBLIC_URL}/images/tax-education.png`} alt="Tax Education" />
                    <h2>Education</h2>
                    <p>Taxes are confusing. Knowledge is power. Learn about some important concepts with us so you can get smart on taxes.</p>
                </div>

                <div className="info-box">
                    <img src={`${process.env.PUBLIC_URL}/images/tax-preparation.png`} alt="Tax Preparation" />
                    <h2>Filing</h2>
                    <p>Unburden yourself from taxes. Full service filing with Salva for professional, accurate, and maximized returns. </p>
                </div>

                <div className="info-box">
                    <img src={`${process.env.PUBLIC_URL}/images/tax-visualization.png`} alt="Tax Visualization" />
                    <h2>Insights</h2>
                    <p>Visualize your taxes. Track key metrics. Understand your taxes once and for all. Available 24/7 for all of our valued clients.</p>
                </div>



               
            </section>
        </div>
    );
}

function AppContent() {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false); // Mobile menu state

    usePageTitle();                // Set dynamic page title
    const isDashboard = useIsDashboard();  // Check if on Dashboard page

    return (
        <div className={isDashboard ? 'hide-header' : ''}>
            {/* Hide header on Dashboard */}
            {!isDashboard && (
                <header>
                    {/* Logo Integration */}
                    <Link to="/">
                        <img
                            src={`${process.env.PUBLIC_URL}/salvalogos/salva_logo_black_cropped.png`}
                            alt="Salva.Tax Logo"
                            className="logo-img"
                        />
                    </Link>

                    {/* Mobile Hamburger Menu */}
                    <div className="hamburger-menu" onClick={() => setMenuOpen(!menuOpen)}>
                        <FaBars />
                    </div>

                    <nav className={`navigation ${menuOpen ? 'show' : ''}`}>
                        <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
                        <Link to="/education" onClick={() => setMenuOpen(false)}>Education</Link>
                        <Link to="/pricing" onClick={() => setMenuOpen(false)}>Pricing</Link>
                        <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
                        <button className="btnLogin-popup" onClick={() => { setIsPopupOpen(true); setMenuOpen(false); }}>Client Portal</button>
                    </nav>
                </header>
            )}

            {/* Login/Register Popup */}
            <LoginRegister isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />

            {/* Routes */}
            <Routes>
                <Route path="/" element={<HomePage onLoginClick={() => setIsPopupOpen(true)} />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/education" element={<Education />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/about" element={<About />} />
                <Route path="/" element={<LoginRegister isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />} />
                <Route path="/reset-password" element={<ResetPassword />} />
            </Routes>

            {/* Copyright Footer */}
            <Footer />

        </div>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;
